import connector from "@/repository/connector";

export default {
  async stats() {
    return connector.requestWithFallback(
      () => connector.connector.get("users/stats/"),
    );
  },
};
